<form [formGroup]="rsoForm">
    <div class="grid-row ml28">
        <input type="radio" id="north-option" formControlName="rsoVal" value='0' (change)="handleChange($event)"
            class="radio-dimension custom-radio">
        <label class="signifyBookmd ml-10" for="north-option" aria-label="Always stays closed">Always
            stays
            closed</label>
    </div>
    <div class="grid-row ml28">
      <input (change)="handleChange($event)" formControlName="rsoVal" id="south-option" type="radio" value='1'
            class="radio-dimension custom-radio"><label class="signifyBookmd ml-10" for="south-option" aria-label="Switches with SR input commands">Switches
            with SR input commands</label>
    </div>
</form>
